<template>
  <div
    class="col-xs-12"
    :style="style"
  />
</template>

<script>
export default {
  name: 'Spacer',
  props: ['height'],
  computed: {
    style() {
      return `height:${this.height}px;`
    },
  },
}
</script>
